import React, { Component } from 'react'
// import moment from 'moment'
// import 'moment/locale/fi'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap'
import Alert from '../Alerts/FalconAlert'
import Autocomplete from '@mui/material/Autocomplete'
import Form from '@rjsf/mui'
import validator from '@rjsf/validator-ajv8'
import { sanitizeSchema } from '../utils/rjsfSchema'
// import TextWidget from '@rjsf/mui'
// import TextWidget from '@rjsf/mui/TextWidget'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
// import moment from 'moment'
// import 'moment/locale/fi'
import ImageSelectDialog from './ImageSelectDialog'
import MultiImageSelectDialog from './MultiImageSelectDialog'
import TinyEditor from '../Editor/TinyEditor'
import { Typography } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import Checkbox from '@mui/material/Checkbox'
import ListItemText from '@mui/material/ListItemText'
import { entityDetails } from '../utils/teams'

const getDifference = (a, b) => {
  const safeA = a && typeof a === 'object' ? a : {}
  const safeB = b && typeof b === 'object' ? b : {}
  return Object.entries(safeB)
    .filter(([key, val]) => safeA[key] !== val && key in safeA)
    .reduce((acc, [key, v]) => ({ ...acc, [key]: v }), {})
}

const CustomTimeWidget = (props) => {
  // console.log(props)
  // delete props.uiSchema
  // delete props.readonly
  // delete props.formContext
  return (
    <TextField
      type='time'
      onChange={(event) => props.onChange(event.target.value)}
      InputLabelProps={{
        shrink: true,
      }}
      value={(props.value || '04:00')}
      label={(props.label || '')}
    />
  );
  // return (
  //   <TextField
  //   id='starttime'
  //   label='Alkuaika'
  //   type='time'
  //   onChange={(e) =>
  //     this.setReservationTime('start', e.target.value)
  //   }
  //   defaultValue={
  //     this.state.selectedResource
  //       ? moment(this.state.selectedResource.start).format(
  //           'HH:mm'
  //         )
  //       : moment().format('HH:mm')
  //   }
  //   InputLabelProps={{
  //     shrink: true,
  //   }}
  // />
  // );
}

const CustomPersonWidget = (props) => {
  // console.log(props)
  return (
    <Autocomplete
      multiple
      options={props.searchable || []}
      getOptionLabel={props.handleOptionLabel} // {option => option.name}
      onChange={props.handleParticipant}
      isOptionEqualToValue={(option, val) => {
        return option.id === val.id
      }}
      value={props.persons || []}
      onInputChange={(event, newInputValue) => {
        if (newInputValue.length > 2) {
          props.search(newInputValue).map((p) => p.item)
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant='standard'
          label='Lisää henkilö'
          placeholder='Henkilöt'
          margin='normal'
          fullWidth
        />
      )}
    />
  )
}


const CustomImageWidget = (props) => {
  return (
    <>
      <ImageSelectDialog  {...props} images={props.schema.items.images} value={props.value} label={props.label} onChange={props.onChange} />
    </>
    
  )
}

// Array counterpart of CustomImageWidget. Props are passed explicitly rather than spread:
// rjsf's array-as-custom-widget path also hands over multiple, registry, options, rawErrors
// and friends, which would leak onto DOM elements. Note onChange here receives the whole
// array, not a single item.
const CustomMultiImageWidget = (props) => {
  const library = (props.schema && props.schema.items && props.schema.items.library) || []
  const value = Array.isArray(props.value) ? props.value : []
  const formContext = (props.registry && props.registry.formContext) || props.formContext || {}
  return (
    <MultiImageSelectDialog
      images={library}
      value={value}
      label={props.label}
      disabled={props.disabled}
      minaspectratio={props.schema && props.schema.minaspectratio}
      mainImage={formContext.image}
      onChange={props.onChange}
    />
  )
}

const CustomEditorWidget = (props) => {
  return (
    <>
      <Typography variant='caption'>{props.label}</Typography>
      <TinyEditor {...props} onChange={props.onChange} disableSave={true} />
    </>
  )
}
      
const CustomImageViewerWidget = (props) => {
  if (!props.value) return <></>
  return (
    <>
      <img src={props.value} alt={props.label} />
    </>
  )
}


// Picks which combination (family) ticket a variation belongs to, from its siblings in the same
// event. formContext is the whole live form data (see the Form below), so the options update as
// the admin types.
//
// It writes the variation's ID, not its name. Writing the name meant the id was reconstructed at
// save time by looking the name back up (firebase.resolveCombinationIds), which produced an empty
// combinationId whenever the name did not resolve - and an empty reference is invisible in the
// editor but fatal at payment time: paymentv3 expands a combination by finding the siblings that
// point at it, finds none, empties the order and throws after the customer has already paid.
//
// A combination variation created in the same session has no id yet (ids are assigned at save),
// so the value falls back to its name; resolveCombinationIds maps that to the real id on save.
const CustomCombinationVariationWidget = (props) => {
  const formContext = (props.registry && props.registry.formContext) || props.formContext || {}
  const variations = formContext.variations || []
  const options = variations
    .filter((v) => v && v.isCombination === 'true' && v.name)
    .map((v) => ({ value: v.id || v.name, label: v.name }))
  return (
    <TextField
      select
      fullWidth
      disabled={props.disabled}
      label={props.label || ''}
      value={props.value || ''}
      onChange={(event) => props.onChange(event.target.value)}
    >
      {options.map((o) => (
        <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
      ))}
    </TextField>
  )
}

// Picks one of the venue's organisations and stores its document ID. The list comes in through
// ui:options.organisations, filled by the container - an admin cannot be expected to know a
// Firestore id, which is what the plain text field this replaces asked for.
//
// Searched locally over a list the container fetched, deliberately not through
// PersonAndOrganisationSearch: that reads firebase.searchCombined, whose Fuse cache is only
// filled once ReservationModal has run, so it comes up empty on a directly opened page.
//
// Options and the picked value both show the business id and email, not just the name: two
// clubs can share a trading name, and a wrong pick has to be visible (same lines as the
// Joukkueet payer card, via entityDetails).
//
// An id that is not in the list (organisation deleted, or typed by hand before this widget
// existed) is kept and flagged rather than cleared - clearing it would silently rewrite the
// saved config the moment the form is opened.
const organisationSearchText = (o) =>
  [o.name, o.businessId, o.email].filter(Boolean).join(' ').toLowerCase()

const CustomOrganisationWidget = (props) => {
  const organisations = (props.options && props.options.organisations) || []
  const selected = props.value ? organisations.find((o) => o.id === props.value) || null : null
  const missing = !!props.value && !selected
  return (
    <>
      <Autocomplete
        options={organisations}
        value={selected}
        disabled={props.disabled || props.readonly}
        getOptionLabel={(o) => o.name || o.id}
        isOptionEqualToValue={(option, val) => option.id === val.id}
        filterOptions={(options, state) => {
          const term = (state.inputValue || '').trim().toLowerCase()
          if (!term) return options
          return options.filter((o) => organisationSearchText(o).includes(term))
        }}
        renderOption={(optionProps, o) => (
          <li {...optionProps} key={o.id}>
            <div>
              <div>{o.name || o.id}</div>
              <Typography variant='caption' color='text.secondary'>
                {entityDetails(o).join(' · ')}
              </Typography>
            </div>
          </li>
        )}
        onChange={(event, o) => props.onChange(o ? o.id : undefined)}
        renderInput={(params) => (
          <TextField
            {...params}
            variant='standard'
            label={props.label || ''}
            required={props.required}
            placeholder='Etsi yritys tai seura'
            margin='normal'
            fullWidth
          />
        )}
      />
      {selected ? (
        <Typography variant='body2' color='text.secondary'>
          {entityDetails(selected).join(' · ')}
        </Typography>
      ) : null}
      {missing ? (
        <Typography variant='body2' color='error'>
          Yritystä ei löydy (tunnus: {props.value}). Valitse yritys uudelleen.
        </Typography>
      ) : null}
    </>
  )
}

const widgets = {
  timeWidget: CustomTimeWidget,
  organisationWidget: CustomOrganisationWidget,
  personWidget: CustomPersonWidget,
  imageWidget: CustomImageWidget,
  multiImageWidget: CustomMultiImageWidget,
  editorWidget: CustomEditorWidget,
  imageViewerWidget: CustomImageViewerWidget,
  combinationVariationWidget: CustomCombinationVariationWidget
};

// Field for a ticket variation's extrainfo: a multi-select of the ticket's
// extra-info questions (read from formContext), storing the selected ids
// (or, before ids exist, the question title as a temporary key).
const CustomExtraInfoSelectField = (props) => {
  const formContext = (props.registry && props.registry.formContext) || {}
  const options = (formContext.extrainfo || []).filter((e) => e && (e.id || e.title))
  const keyOf = (e) => e.id || e.title
  const value = Array.isArray(props.formData) ? props.formData : []
  return (
    <FormControl fullWidth size='small' style={{ marginTop: 8 }}>
      <InputLabel>Kysytyt lisätiedot</InputLabel>
      <Select
        multiple
        value={value}
        label='Kysytyt lisätiedot'
        onChange={(e) => props.onChange(e.target.value, props.fieldPathId && props.fieldPathId.path)}
        renderValue={(sel) =>
          options.filter((o) => sel.includes(keyOf(o))).map((o) => o.title).join(', ')
        }
      >
        {options.map((o) => (
          <MenuItem key={keyOf(o)} value={keyOf(o)}>
            <Checkbox checked={value.indexOf(keyOf(o)) > -1} />
            <ListItemText primary={o.title} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

const fields = {
  extraInfoSelectField: CustomExtraInfoSelectField,
};

// rjsf v6 falls back to the schema property name when no explicit title is
// set, and auto-generates per-item titles like `${arrayName}-${index+1}` for
// arrays of objects. Both surface raw schema keys to the user. Suppress them
// when the schema has no real title; render normally when one is provided.
const SmartTitleField = (props) => {
  if (props.id && /_\d+__title$/.test(props.id)) return null
  const schemaTitle = props.schema && props.schema.title
  if (!schemaTitle) return null
  return <Typography id={props.id} variant='h5'>{props.title}</Typography>
}

const templates = {
  TitleFieldTemplate: SmartTitleField,
};


class FalconModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: props.isOpen,
      formData: this.props.resource || {},
      inputerror: false
    }
  }

  componentDidMount() {
    if (this.props.resource) {
      // console.log('Adding form data')
      this.setState({ formData: this.props.resource })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      if (this.props.isOpen) {
        this.setState({ isOpen: this.props.isOpen, formData: this.props.resource || {} })
      } else {
        this.setState({ isOpen: this.props.isOpen })
      }
    }
  }

  clearState = () => {
    this.setState({ formData: {} }, this.props.toggle)
  } 

  onSave = (event) => {
    event.preventDefault()
    const data = this.state.formData
    // delete data.id
    if (data.id) {
      delete data.actions
      // console.log(data)
      this.props.onUpdate(data).then((dataSnapshot) => {
        this.clearState()
        if(this.props.modifiedCallback) this.props.modifiedCallback(dataSnapshot)
      }).catch((error) => console.error(error))
    } else {
      // console.log(this.props.onCreate)
      this.props.onCreate(data).then((dataSnapshot) => {
        this.clearState()
        if(this.props.modifiedCallback) this.props.modifiedCallback(dataSnapshot)
      }).catch((error) => console.error(error))
    }
  }

  onFormChange = (formData) => {
    console.log('Form changed', formData)
    const diffs = getDifference(this.state.formData, formData)
    this.setState({ formData: formData })
    if (this.props.validate) {
      this.props.validate(diffs).then((result) => {
        // console.log(result)
        this.setState({ inputerror: false, errorAlert: <></> })
      }).catch((error) => {
        console.error('Error', error)
        this.setState({ inputerror: true, errorAlert: <Alert color='danger'>{error.error}</Alert> })
      })
    }
  }

  onButtonClick = (button) => {
    this.setState({ formData: { ...this.state.formData, state: button } })
    this.onSave()
    if (this.props.onButtonCallback) this.props.onButtonCallback(button)
  }

  render() {
    const isDisabled = this.state.formData && this.state.formData.hasOwnProperty('editable') && !this.state.formData.editable
    // disableSave also accepts a predicate over the LIVE form data, not just a boolean fixed
    // when the modal opened. Editors whose validity depends on what has been typed so far
    // (a team format needs at least one rubber) cannot express that any other way: the parent
    // holds only the resource the modal opened with, and formData lives in here.
    const saveDisabled =
      typeof this.props.disableSave === 'function' ? this.props.disableSave(this.state.formData) : this.props.disableSave
    // if (this.state.formData) {
    //   console.log(this.state.formData.hasOwnProperty('editable'))
    // }
    return (
      <div>
        <Modal
          isOpen={this.state.isOpen}
          toggle={this.props.toggle}
         size={this.props.size || 'md'}
        >
          <ModalHeader toggle={(this.props.cancel ? this.props.cancel : this.props.toogle)}>
            {this.props.title}
          </ModalHeader>
          <ModalBody>
            {this.state.errorAlert}
            <Form
              schema={sanitizeSchema(this.props.dataSchema)}
              uiSchema={this.props.uiSchema}
              formData={this.state.formData}
              formContext={this.state.formData}
              onChange={e => this.onFormChange(e.formData)}
              widgets={widgets}
              fields={fields}
              templates={templates}
              disabled={isDisabled}
              validator={validator}
            >
              <Button color='success' disabled={this.state.inputerror || saveDisabled} onClick={this.onSave}>
                Tallenna
              </Button>
            </Form>
          </ModalBody>
          {/* renderFooter gets the live form data so an editor can show a readout that updates
              as the admin types. Optional; every existing caller leaves the footer empty. */}
          <ModalFooter>{this.props.renderFooter ? this.props.renderFooter(this.state.formData) : null}</ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default FalconModal
